import type { ClubLocation } from 'src/models/club-location';

export const getUserLocation = async () => {
  if (window.navigator && navigator.geolocation) {
    try {
      const position: GeolocationPosition = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      });
      return position.coords;
    } catch {
      return;
    }
  }
  return;
};

export const getDistanceFromCurrentLocation = (
  siteId: string,
  clubLocations: Record<string, ClubLocation>,
  currentLocation: ClubLocation
) => {
  const clubLocation = clubLocations[siteId];
  return clubLocation && euclideanDistance(clubLocation, currentLocation);
};

const euclideanDistance = (location1: ClubLocation, location2: ClubLocation) => {
  return Math.sqrt(
    Math.pow(location1.longitude - location2.longitude, 2) +
      Math.pow(location1.latitude - location2.latitude, 2)
  );
};
